<template>
    <div class="col-12" :class="{'col-md-6' : view === 'RE'}" :id="folder">
        <div class="form-group">
            <label v-if="label">{{$t(label)}}</label>
            <vue-dropzone :id="code"
                          :ref="code"
                          :options="dropZoneOptions"
                          :destroyDropzone="false"
                          @vdropzone-mounted="onDropZoneMounted"
                          @vdropzone-upload-progress="onDropZoneProgress"
                          @vdropzone-success="onDropZoneSuccess"
                          @vdropzone-error="onDropZoneError"
                          @vdropzone-removed-file="onDropZoneRemove"
                          @vdropzone-file-added="onDropZoneFileAdded"
                          @vdropzone-files-added="onDropZoneFilesAdded"
                          :class="{'invalid' : hasError, 'has-file': files.length > 0}"
            >
            </vue-dropzone>
        </div>
    </div>
</template>

<script>
    import {BASE_API_UPLOAD} from '@/axios';
    import Cookie from 'js-cookie';
    import $ from 'jquery';
    import {clickImage} from '@/shared/utils';
    import {mapState} from "vuex";
    import {getArchiveModeDetailsByVersion} from "@/shared/archive-mode-utils";

    export default {
        // props: ['code', 'label', 'view', 'folder', 'maxFiles', 'data'],
        props: {
            code: String,
            label: String,
            folder: {
                type: String,
                default: ''
            },
            data: Array,
            view: {
                type: String,
                default: 'RE'
            },
            maxFiles: {
                type: Number,
                default: 100
            },
            hasError: {
                type: Boolean,
                default: false
            },
            url: {
                type: String,
                default: 'upload/save/new',
            },
            acceptedFiles: {
                type: String,
                default: "image/*,application/pdf",
            },
            callBackData: {
                type: Boolean,
                default: false
            },
            editable: {
                type: Boolean,
                default: true,
            },
            removeFile: {
                type: Boolean,
                default: false
            }
        },
        computed: {
          ...mapState(['archiveModeVersion'])
        },
        data() {
            const vm = this;
            return {
                dropZoneOptions: {
                    url: BASE_API_UPLOAD + this.$props.url,
                    maxFiles: this.maxFiles,
                    acceptedFiles: this.$props.acceptedFiles,
                    addRemoveLinks: this.$props.removeFile,
                    clickable: this.$props.editable,
                    uploadMultiple: true,
                    paramName: function () {
                      return "file";
                    },
                    headers: { 
                        'Authorization': `Bearer ` + Cookie.get('x_token_' + process.env.VUE_APP_NAME),
                        "folderName": "RealEstate",
                        "subFolderName": vm.folder,
                    },
                    dictDefaultMessage: this.$t('dropzone.defaultMessage'),
                    dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
                    dictCancelUpload: this.$t('dropzone.cancelUpload'),
                    dictCancelUploadConfirmation: this.$t('dropzone.cancelUploadConfirmation'),
                    dictRemoveFile: this.$t('dropzone.removeFile'),
                    dictRemoveFileConfirmation:  this.$t('dropzone.removeFileConfirmation')
                },
                files: [],
                files_added: []
            }
        },
        mounted() {
          this.updateDropzoneURL();
        },
        methods: {
            initFiles() {
                const dropZone = this.$refs[this.code];
                if (this.data && this.data.length > 0 && dropZone) {
                    this.data.forEach((file, index) => {
                        if (file && file.id && file.id > 0 && file.filePath && file.filePath.length > 0) {
                            if (!this.files_added.includes(file.id)) {
                                dropZone.manuallyAddFile(file, file.filePath);
                                this.files.push(file);
                                this.files_added.push(file.id);
                                var drop_zone_divs = $("#" + this.code + " > div.dz-preview .dz-image > img");
                                drop_zone_divs[index].setAttribute("url", file.filePath);
                            }
                        }
                    });
                    clickImage("#" + this.code);
                    this.rotateDropZone();
                }
            },
            onDropZoneProgress(file, progress, bytesSent) {
                this.processing = true;
                console.log('dz-progress:' + progress + ':' + bytesSent);
            },
            onDropZoneSuccess(file, response) {
                if (this.callBackData) {
                    this.$emit('change', response.data);
                    return;
                }

                this.processing = false;
                if (!this.files) {
                    this.files = [];
                }
                if (response) {
                    if (response.data && response.data.id && response.data.id > 0) {
                        if (!this.hasFileId(response.data.id)) {
                            this.files.push(response.data);
                            this.files_added.push(response.data.id);
                        }
                    } else if (response.length > 0) {
                        response.forEach((file) => {
                            if (!this.hasFileId(file.id)) {
                                this.files.push(file);
                                this.files_added.push(file.id);
                            }
                        });
                    }
                }
                this.$emit('change', this.files);
                console.log('dz-success');
                console.log(response);
            },
            hasFileId(fileId) {
                let hasFile = false;
                if (this.files && this.files.length > 0) {
                    this.files.forEach((file) => {
                        if (file.id === fileId) {
                            hasFile = true;
                        }
                    });
                }
                return hasFile;
            },
            onDropZoneError() {
                this.processing = false;
                console.log('dz-error');
            },
            onDropZoneRemove(file/*, error, xhr*/) {
                if (this.files && this.files.length > 0) {
                    let fileIndex = null;
                    let hasFile = false;
                    for (let i = 0; i < this.files.length; i++) {
                        if (this.files[i].id === file.id) {
                            fileIndex = i;
                            hasFile = true;
                        }
                    }

                    if (hasFile) {
                        this.$http.post('/upload/remove', {userId: null, data: file.id}).then(res => {
                            if (res.data.status === 200) {
                                this.$swal({
                                    title: this.$t('messages.common.success'),
                                    text: this.$t('messages.common.removeFileDone'),
                                    type: 'success'
                                });
                            }
                        }, () => {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.common.errorOccurred'),
                                type: 'error'
                            });
                        });
                        this.files.splice(fileIndex, 1);
                    }
                }
                this.$emit('change', this.files);
                console.log('dz-remove');
            },
            onDropZoneMounted() {
                console.log('dz-mounted');
                this.initFiles();
            },
            onDropZoneFileAdded(file) {
                // console.log('file_added_url', file.filePath);
                this.onFileAdded(file);
            },
            onDropZoneFilesAdded(files) {
                // console.log('files_added', files);
                if (files && files.length > 0) {
                    for (let i = 0; i < files.length; i++) {
                        this.onFileAdded(files[i]);
                    }
                }
            },
            onFileAdded(file) {
                if (file && file.type && file.type.length > 0 && file.type.startsWith('image')) {
                    file.previewElement.addEventListener("click", () => {
                        // this.$eventBus.$emit('showDropZoneImagePreview', {
                        //     url: (file.filePath && file.filePath.length > 0 ? file.filePath : file.dataURL)
                        // });
                        // console.log('file_details_clicked', file.filePath);
                    });
                }
            },
            rotateDropZone() {
                if (this.hasPermission('REAL_ESTATE_IMAGE_ROTATE')) {
                    const vm = this;
                    setTimeout(() => {
                        var dropZoneId = $("#" + this.code + " > div.dz-preview");

                        var imgDivs = $(dropZoneId);
                        for (var i = 0; i < imgDivs.length; i++) {
                            var div = $(imgDivs[i]);
                            var image = div.children(".dz-image").children("img");

                            var imageSrc = image.attr("src");
                            var ext = this.fileExtension(imageSrc);

                            if (ext === "pdf" || ext === "PDF") {
                                // autoCommon.func.warningMsg("Faqat Rasmlar uchun");
                                continue;
                            }

                            var imageAlt = image.attr("alt");
                            if (!imageAlt){
                                continue;
                            }
                            imageAlt = imageAlt.replace(".", "_");
                            // console.log(imageAlt);

                            var leftId = "left_" + imageAlt;
                            var rightId = "right_" + imageAlt;

                            var leftBtn = "<a src='" + imageSrc + "' id='" + leftId + "' class='all-btn add-btn' ><i class='fa fa-mail-reply'></i></a>";
                            var rightBtn = "<a src='" + imageSrc + "' id='" + rightId + "' class='all-btn add-btn' ><i class='fa fa-mail-forward'></i></a>";
                            // var rightBtn = "<a class='btn btn-primary'><i class='fa fa-mail-forward'></i></a>";
                            var rotateContent = "<div class='margin-top-10 d-flex align-items-center'>" + leftBtn + "<span class='padding-10'>Расм айлантириш</span>" + rightBtn + "</div>";
                            div.append(rotateContent);

                            $("#" + leftId).on('click', function (event) {
                                var leftUrl = $(event.currentTarget).attr("src");
                                console.log(leftUrl);
                                vm.rotateImage(leftUrl, -90);
                            });

                            $("#" + rightId).on('click', function (event) {
                                var rightUrl = $(event.currentTarget).attr("src");
                                console.log(rightUrl);
                                vm.rotateImage(rightUrl, 90);
                            });
                        }
                    }, 1000);
                }
            },
            fileExtension(url) {
                if (url) {
                    return url.split('.').pop();
                }
                return "";
            },
            rotateImage(imageUrl, rotate) {
                // console.log(imageUrl, rotate);
                const data = {
                    "entityId": null,
                    "filePath": imageUrl,
                    "rotate": rotate
                };

                this.processing = true;
                this.$http.put('/image-rotate', data)
                    .then(res => {
                        this.processing = false;

                        if (res.data.status === "SUCCESS") {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: res.data.message,
                                type: 'success'
                            });
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: res.data.message,
                                type: 'success'
                            });
                        }
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
            updateDropzoneURL() {
              this.dropZoneOptions.url = (this.archiveModeVersion ? getArchiveModeDetailsByVersion(this.archiveModeVersion).url : BASE_API_UPLOAD) + this.$props.url;
              if(this.$refs[this.$props.code] && this.$refs[this.$props.code].dropzone && this.$refs[this.$props.code].dropzone.options) {
                this.$refs[this.$props.code].dropzone.options.url = (this.archiveModeVersion ? getArchiveModeDetailsByVersion(this.archiveModeVersion).url : BASE_API_UPLOAD) + this.$props.url
              }
            }
        },
        watch: {
            // Watch for value change
            data: {
                immediate: true,
                // handle the changed value
                handler() {
                    // console.log(val);
                    this.initFiles();
                }
            },
            editable: {
                immediate: true,
                handler() {
                    // console.log('editable: =',val);
                }
            }
        }
    }
</script>

<style>

</style>
